import React from 'react'
import { ChartHeader, PrintChartItem } from './header-utils'
import { CHART_PRINT_ID } from '../../../dynamic-power-prices/config'
import { Box, IconButton, Tooltip, useMediaQuery, useTheme } from '@mui/material'
import { J1Diagonalarrowzoom } from '@e3dc-react/icons'
import { useLastTimeFetched } from '../hooks'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import ExportCostSavingData from 'src/Libs/dynamic-power-prices/components/cost-savings-chart/ExportCostSavingData'
import VisibilityIcon from 'src/Elements/VisibilityIcon'

interface Props {
  title?: string
  toggleLegendVisibility: () => void
  resetZoom: () => void
  isZoomedIn: boolean
  showLegend: boolean
}

/**
 * The chart's header displaying a title and allowing to print and download the chart
 *
 * TODO: implement functionality (printing works more or less already)
 */
const ChartHeaderPrintDownload: React.FC<Props> = ({ title, showLegend, toggleLegendVisibility, resetZoom, isZoomedIn }) => {
  const dataFetchTimeStamp = useLastTimeFetched()
  const theme = useTheme()
  const upMd = useMediaQuery(theme.breakpoints.up('md'))
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))
  const { t } = useCustomTranslation()
  const filename = t('dynamic-power-prices.cost-saving-chart.csv-export.file-name')

  return (
    <ChartHeader title={title}>
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
        <Tooltip title={t('systemDataHandler.chartHeader.reset-chart-zoom')}>
          <Box component="span">
            <IconButton disabled={!isZoomedIn} onClick={resetZoom} size="large" sx={{ color: 'primary.main' }}>
              <J1Diagonalarrowzoom />
            </IconButton>
          </Box>
        </Tooltip>
        {upMd && (
          <>
            <PrintChartItem title={title} dataFetchTimeStamp={dataFetchTimeStamp} printElementId={CHART_PRINT_ID} />
            <ExportCostSavingData filename={filename} dataQa={`electricity-chart-csv-button`} />
          </>
        )}
        {downSm && <VisibilityIcon isHidden={!showLegend} onClick={toggleLegendVisibility} />}
      </Box>
    </ChartHeader>
  )
}

export default ChartHeaderPrintDownload
